import { objectParamsConfig } from 'src/navigation/linking/utils';
export const reviewPipelineStackLinking = {
    screens: {
        RP_Home: {
            path: 'review-pipeline/*',
            ...objectParamsConfig(['filters']),
        },
        RP_ReviewDetails: {
            path: 'review-pipeline/details/:reviewEntityID',
        },
    },
};
